import angular from 'angular';
import CSMCommonWeb from 'csm-common-web';
import { AdjustmentsServices } from './services/AdjustmentsServices';

export default angular
  .module('csm.books.Adjustments', [CSMCommonWeb, 'csm.remoting'])
  .service('AdjustmentsServices', AdjustmentsServices)
  .name;
